<template>
    <div>
        <template v-if="checkActionAllow('finance_request_change_status')">
            <b-button-group size="sm" class="w-100">
                <b-button 
                    variant="table"
                    @click="changeFinanceRequestStatus(row.index, 312)"
                    :disabled="row.item.reference_status_id != 311"
                    title="В работе"
                >
                    <i class="far fa-clock text-primary"></i>
                </b-button>
                <b-button 
                    variant="table"
                    @click="changeFinanceRequestStatus(row.index, 313)"
                    :disabled="row.item.reference_status_id == 313 || row.item.reference_status_id == 314"
                    title="Выполнено"
                >
                    <i class="fas fa-check text-success"></i>
                </b-button>
                <b-button 
                    variant="table"
                    @click="changeFinanceRequestStatus(row.index, 314)"
                    :disabled="row.item.reference_status_id == 313 || row.item.reference_status_id == 314"
                    title="Отменен"
                >
                    <i class="fas fa-times text-danger"></i>
                </b-button>
            </b-button-group>
        </template>
        <div class="mt-1" style="display:flex; justify-content: center;">
            <span
                v-if="checkActionAllow('go_to_finance_operation')"
                @click="openFinanceSidebar(row.item.finance_id)"
                class="table_actions_supply"
                :style="isNotAccountant ? 'width: 60px;' : 'width: 100%;'"
            >
                <span class="table_actions_supply_create_score-title">Счёт</span>
            </span>

            <b-button 
                variant="table"
                size="sm"
                @click="changeFinanceRequestStatus(row.index, 314)"
                v-if="isNotAccountant"
                :disabled="row.item.reference_status_id == 313 || row.item.reference_status_id == 314"
                title="Отменен"
            >
                <i class="fas fa-times text-danger"></i>
            </b-button>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { checkActionAllow } from '@/mixins';
    import { openFinanceSidebar } from '@/mixins/openFinanceSidebar';

    export default {
        props: {
            row: {                            // Row of table
                type: Object, 
                required: true
            },
            actionAllows: {                   // Array of rules for action allows
                type: Array, 
                default: () => []
            }
        },
        mixins: [
            checkActionAllow,
            openFinanceSidebar
        ],
        data() {
            return {
            }
        },
        computed: {
            ...mapGetters('auth', ['currentUser']),

            isNotAccountant() {
                return !this.currentUser.role.includes('accountant') 
                    && !this.currentUser.role.includes('head-accountant');
            }
        },
        mounted() {
        },
        methods: {
            changeFinanceRequestStatus(index, status_id) {
                this.$emit('universalEmit', 'changeFinanceRequestStatus', index, status_id)
            },
        }
    }
</script>



